// UI chartMode → registry key. Coffee does the mapping in 2 steps (UI → 'columns'/'stacked'/...
// → internal data_lab class name). In React this is 1 step: both the UI mapping and the dl_*
// registry live in a single namespace (chartRegistry).
export const mapToBuilderKey = (chartMode, hasBatches) => {
  if (!hasBatches) {
    // Single-batch: same as regular Column/Bar
    return chartMode // respondents | percents | brespondents | bpercents
  }
  // Multi-batch: Data Lab Columns (corresponds to _chartModeMap in coffee:55-59)
  switch (chartMode) {
    case 'respondents':
      return 'dl_columns'
    case 'percents':
      return 'dl_stacked'
    case 'brespondents':
      return 'dl_bcolumns'
    case 'bpercents':
      return 'dl_bstacked'
    default:
      return 'dl_columns'
  }
}

// Coffee has a three-level fallback (arg → model.chartMode → page.model.chartMode).
// renderReactChart already passes the resolved value (model || page.model), so here
// the two-level fallback (arg → globalChartMode) is equivalent.
export const getDefaultChartMode = ({ qType, chartMode, globalChartMode }) => {
  let mode = chartMode === 'off' ? globalChartMode : chartMode
  mode = mode || globalChartMode

  if (qType === 'bars' && !['respondents', 'brespondents'].includes(mode)) {
    return 'respondents'
  }
  if (qType === 'stacked-bars' && !['percents', 'bpercents'].includes(mode)) {
    return 'percents'
  }
  return mode
}
